module.exports = __webpack_public_path__ + "static/media/icon_sho39299d2869726713076775be2dcadd6e.webp";